export const Dot11PhyTypeMap = new Map<number, string>([
    [0, "Unknown"],
    [1, "FHSS"],
    [2, "DSSS"],
    [3, "IRBaseband"],
    [4, "OFDM(802.11a)"],
    [5, "HRDSS(802.11b)"],
    [6, "ERP(802.11g)"],
    [7, "HT(802.11n)"],
    [8, "VHT(802.11ac)"],
    [10, "HE(802.11ax)"],
    [0x80000000, "IHV_start"],
    [0xffffffff, "IHV_end"],
])